/* Çerez izni bandı — KVKK'ya uygun açık rıza.
 *
 * NEDEN KENDİ BANDIMIZ
 *   Shopify'ın hazır çerez bandı yalnızca yöneticiden açılabiliyor; Admin
 *   API'de karşılığı yok (yalnız `privacyFeaturesDisable` var). Mağazada GA4,
 *   Google Ads ve Merchant Center etiketleri çalıştığı için izin toplayan bir
 *   yüzey ŞART. Kendi bandımız hem Türkçe hem mağazanın tasarımıyla aynı.
 *
 * NASIL ÇALIŞIR
 *   Shopify'ın Customer Privacy API'si (`consent-tracking-api`) izni saklar ve
 *   izin verilene kadar etiketleri BEKLETİR. Biz yalnızca kararı topluyoruz:
 *   setTrackingConsent ile yazıyoruz, Shopify gerisini hallediyor.
 *
 * KVKK KURALLARI — BUNLAR TASARIM DEĞİL, ZORUNLULUK
 *   1. Açık rıza: hiçbir kutu önceden işaretli değildir (zorunlu çerezler hariç).
 *   2. Reddetmek kabul etmek kadar kolay olmalı: "Tümünü reddet" düğmesi
 *      "Tümünü kabul et" ile aynı belirginlikte ve aynı tıklama uzaklığında.
 *   3. Karar verilene kadar hiçbir isteğe bağlı çerez çalışmaz.
 *   4. Karar her zaman değiştirilebilir: footer'daki "Çerez Tercihleri".
 */

const STORAGE_KEY = 'rod:consent:v1';
const root = document.querySelector('[data-rod-consent]');

if (root) {
  const banner = root.querySelector('[data-rod-consent-banner]');
  const dialog = root.querySelector('[data-rod-consent-dialog]');
  const analytics = root.querySelector('[data-rod-consent-analytics]');
  const marketing = root.querySelector('[data-rod-consent-marketing]');
  let lastFocus = null;

  /** Shopify'ın izin API'si hazır olana kadar bekler. */
  const privacyApi = () => new Promise((resolve) => {
    if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return resolve(null);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      resolve(error ? null : window.Shopify.customerPrivacy ?? null);
    });
  });

  const write = async (consent) => {
    // Yerel kopya yalnızca bandı tekrar göstermemek için; GERÇEK kayıt
    // Shopify'da. İkisi ayrışırsa Shopify kazanır.
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...consent, at: Date.now() })); } catch { /* özel pencere */ }
    const api = await privacyApi();
    if (!api) return;
    api.setTrackingConsent({
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
      sale_of_data: false,
    }, () => { /* Shopify kendi olayını yayar; burada yapacak bir şey yok */ });
  };

  const hideBanner = () => {
    banner.hidden = true;
    root.classList.remove('is-open');
  };

  const closeDialog = () => {
    dialog.hidden = true;
    root.classList.remove('is-dialog');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  };

  const openDialog = () => {
    lastFocus = document.activeElement;
    // Mevcut karar varsa kutular onu yansıtsın; yoksa KAPALI kalır (açık rıza).
    privacyApi().then((api) => {
      const c = api?.currentVisitorConsent?.();
      if (c) {
        analytics.checked = c.analytics === 'yes' || c.analytics === true;
        marketing.checked = c.marketing === 'yes' || c.marketing === true;
      }
    });
    dialog.hidden = false;
    root.classList.add('is-dialog');
    dialog.querySelector('input, button')?.focus();
  };

  const decide = async (consent) => {
    await write(consent);
    hideBanner();
    closeDialog();
  };

  root.querySelector('[data-rod-consent-accept]')?.addEventListener('click', () =>
    decide({ analytics: true, marketing: true, preferences: true }));
  root.querySelector('[data-rod-consent-reject]')?.addEventListener('click', () =>
    decide({ analytics: false, marketing: false, preferences: false }));
  root.querySelector('[data-rod-consent-manage]')?.addEventListener('click', openDialog);
  root.querySelector('[data-rod-consent-close]')?.addEventListener('click', closeDialog);
  // preferences BURADA false: pencerede ziyaretciye yalnizca olcum ve pazarlama
  // soruluyor. true yazmak, sorulmamis bir kategori icin riza kaydetmek olurdu.
  // "Tumunu kabul et" farklidir — orada ziyaretci acikca hepsini demistir.
  root.querySelector('[data-rod-consent-save]')?.addEventListener('click', () =>
    decide({ analytics: analytics.checked, marketing: marketing.checked, preferences: false }));

  dialog?.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDialog(); });

  // Footer'daki "Çerez Tercihleri" bu kancayı kullanır.
  window.rodConsent = { open: openDialog };

  // İlk gösterim: Shopify izin gerekiyor diyorsa VE ziyaretçi henüz karar
  // vermemişse. Karar verilmişse band bir daha çıkmaz.
  //
  // Bant bu noktaya gelmeden, snippets/rod-consent.liquid'deki satır içi betikle
  // İYİMSER olarak gösterilmiş olabilir (ilk çizimde görünsün diye). KESİN karar
  // burada verilir: gerekmiyorsa ya da karar zaten varsa bant kapatılır.
  privacyApi().then((api) => {
    if (!api) return hideBanner();         // API yoksa band göstermek anlamsız
    const required = api.shouldShowBanner?.() ?? true;
    const consent = api.currentVisitorConsent?.();
    const decided = consent && (consent.analytics !== '' || consent.marketing !== '');
    if (required && !decided) {
      banner.hidden = false;
      root.classList.add('is-open');
    } else {
      hideBanner();
    }
  });
}
